// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__VCXHG","name":"ConsentHeader_name__1wpHQ","birthday":"ConsentHeader_birthday__1f9H7","skeleton":"ConsentHeader_skeleton__1RqIJ"};